import {getRouter, NoOperation} from '@/library/utils';
import store from '@/store';
import {isDeveloper, isStaging} from '@/utils/portuna';
import * as Sentry from '@sentry/vue';
import type {App} from 'vue';

let vueApp: App<Element>;

let sentryInitialised = false;

export function setSentryVueApp(app: App<Element>)
{
    vueApp = app;
}

export function initSentry()
{
    if (sentryInitialised)
    {
        return;
    }

    sentryInitialised = true;

    Sentry.init({
        app: vueApp,
        dsn: 'https://1aed6d15863d4255b7ea6e6fc6fddab9@sentry.verwaltungsportal.de/4',
        maxBreadcrumbs: 50,
        environment: isStaging() ? 'staging' : 'master',
        // @see https://docs.sentry.io/platforms/javascript/configuration/filtering/ (denyUrls, ignoreErrors)
        denyUrls: [
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i,
            // external modules
            /ckeditor.js/i,
            /^@sentry\/browser/i,
            /^axios\/lib\/core/i,
            /^(\.\/)?node_modules\/(.+)/i,
        ],
        ignoreErrors: [
            'A network error occurred.',
            'Request aborted',
            'Network Error',
            /^Loading( CSS)? chunk (.+) failed/i,
            /Request failed with status code/i,
            'can\'t access dead object',
            /^Avoided redundant navigation to current location/,
        ],
        integrations: [
            Sentry.browserTracingIntegration({
                router: getRouter(),
            }),
        ],
        beforeSend(event)
        {
            if (event.message?.includes('can\'t access dead object'))
            {
                window.location.reload();
                return null;
            }

            // if admin disable sentry after init
            if (!store.getters.sentryActive)
            {
                return null;
            }

            return event;
        },
    });
}

export function captureSilentError(error: Error)
{
    if (!sentryInitialised || !store.getters.sentryActive)
    {
        return isDeveloper() ? console.error('[Sentry-Capture] Tried to log silent error but sentry is disabled: ', error) : NoOperation;
    }

    Sentry.withScope((scope) =>
    {
        scope.setTag('[Sentry-Capture]', true);

        Sentry.captureException(error);
    });
}